import { type ReactNode } from 'react'
import { Button } from '@/components/Button'
import { Form } from '@/components/Form'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from '@/components/ModalSheet'

export interface AddUserToWorkspaceDialogProps {
  showing: boolean
  onClose: () => void
  onSubmit: () => void
  isSubmitPending: boolean
  /**
   * The form fields.
   */
  children: ReactNode
}

export function AddUserToWorkspaceDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  children,
}: AddUserToWorkspaceDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetSection horizontallySpaced>
          <ModalSheetContentTitle>Add user to workspace</ModalSheetContentTitle>
          <ModalSheetContentDescription compact>
            Select the workspace you wish to add this user to.
          </ModalSheetContentDescription>
        </ModalSheetSection>

        <ModalSheetSection spaced>
          <Form id="addUserToWorkspace" onSubmit={onSubmit}>
            {children}
          </Form>
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            onPress={onClose}
            isDisabled={isSubmitPending}
          />
          <Button
            label="Add User"
            type="submit"
            form="addUserToWorkspace"
            variant="primary"
            isDisabled={isSubmitPending}
            isPending={isSubmitPending}
            testId="add-user-to-workspace-submit"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
